<template>
  <!-- Main Content -->
  <div class="flex-1 p-4 lg:p-8 bg-[#1F1F1F]">
    <div class="flex flex-col lg:flex-row lg:justify-between lg:items-center mb-6 lg:mb-8 gap-4">
      <h1 class="text-2xl lg:text-3xl font-bold text-[#F5BE32]">{{ $t('admin.orders.title') }}</h1>
      <button class="flex items-center justify-center gap-2 px-4 py-2 bg-[#4F4F4F] border border-[#F5BE32] text-[#F5BE32] rounded-lg hover:bg-[#1F1F1F] transition-colors w-full lg:w-auto">
        <span>{{ $t('admin.orders.filter') }}</span>
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
        </svg>
      </button>
    </div>
    
    <!-- Latest Orders Section -->
    <div class="bg-[#4F4F4F] rounded-xl p-4 lg:p-5 border border-[#1F1F1F]">
      <h2 class="text-lg lg:text-xl font-semibold text-white mb-4 lg:mb-5">{{ $t('admin.overview.latestOrders') }}</h2>
      
      <div class="overflow-x-auto">
        <table class="w-full min-w-[700px]">
          <thead>
            <tr class="border-b border-[#1F1F1F]">
              <th class="text-left p-2 lg:p-3 text-gray-300 font-semibold text-xs lg:text-sm">{{ $t('admin.orders.tableHeaders.orderNumber') }}</th>
              <th class="text-left p-2 lg:p-3 text-gray-300 font-semibold text-xs lg:text-sm">{{ $t('admin.orders.tableHeaders.time') }}</th>
              <th class="text-left p-2 lg:p-3 text-gray-300 font-semibold text-xs lg:text-sm">{{ $t('admin.orders.tableHeaders.table') }}</th>
              <th class="text-left p-2 lg:p-3 text-gray-300 font-semibold text-xs lg:text-sm">{{ $t('admin.orders.tableHeaders.reservation') }}</th>
              <th class="text-left p-2 lg:p-3 text-gray-300 font-semibold text-xs lg:text-sm">{{ $t('admin.orders.tableHeaders.amount') }}</th>
              <th class="text-left p-2 lg:p-3 text-gray-300 font-semibold text-xs lg:text-sm">{{ $t('admin.orders.tableHeaders.status') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-b border-[#1F1F1F] cursor-pointer hover:bg-[#1F1F1F]" @click="showOrderSummary = true">
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">42</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">14:30</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">Table 07</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">Alice Smith</td>
                             <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">350</td>
              <td class="p-2 lg:p-3">
                <span class="inline-flex items-center gap-1 px-2 lg:px-4 py-1 bg-[#F5BE32] text-[#1F1F1F] text-xs font-medium rounded-full whitespace-nowrap">
                  <div class="w-2 h-2 bg-[#E5AE22] rounded-full"></div>
                  {{ $t('admin.orders.statuses.preparing') }}
                </span>
              </td>
            </tr>
            <tr class="border-b border-[#1F1F1F] cursor-pointer hover:bg-[#1F1F1F]" @click="showOrderSummary = true">
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">18</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">09:45</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">Table 12</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">Michael Johnson</td>
                              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">150</td>
              <td class="p-2 lg:p-3">
                <span class="inline-flex items-center gap-1 px-2 lg:px-4 py-1 bg-[#F5BE32] text-[#1F1F1F] text-xs font-medium rounded-full whitespace-nowrap">
                  <div class="w-2 h-2 bg-[#E5AE22] rounded-full"></div>
                  {{ $t('admin.orders.statuses.preparing') }}
                </span>
              </td>
            </tr>
            <tr class="border-b border-[#1F1F1F] cursor-pointer hover:bg-[#1F1F1F]" @click="showOrderSummary = true">
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">33</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">11:15</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">Table 09</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">Emily Davis</td>
                             <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">500</td>
              <td class="p-2 lg:p-3">
                <span class="inline-flex items-center gap-1 px-2 lg:px-4 py-1 bg-green-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                  <div class="w-2 h-2 bg-green-600 rounded-full"></div>
                  {{ $t('admin.orders.statuses.served') }}
                </span>
              </td>
            </tr>
            <tr class="border-b border-[#1F1F1F] cursor-pointer hover:bg-[#1F1F1F]" @click="showOrderSummary = true">
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">29</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">16:00</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">05 Pre-Order</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">Chris Brown</td>
                              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">250</td>
              <td class="p-2 lg:p-3">
                <span class="inline-flex items-center gap-1 px-2 lg:px-4 py-1 bg-green-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                  <div class="w-2 h-2 bg-green-600 rounded-full"></div>
                  {{ $t('admin.orders.statuses.served') }}
                </span>
              </td>
            </tr>
            <tr class="border-b border-[#1F1F1F] cursor-pointer hover:bg-[#1F1F1F]" @click="showOrderSummary = true">
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">37</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">13:00</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">Table 10</td>
              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">Sarah Wilson</td>
                              <td class="p-2 lg:p-3 text-white text-xs lg:text-sm">400</td>
              <td class="p-2 lg:p-3">
                <span class="inline-flex items-center gap-1 px-2 lg:px-4 py-1 bg-red-500 text-white text-xs font-medium rounded-full whitespace-nowrap">
                  <div class="w-2 h-2 bg-red-600 rounded-full"></div>
                  {{ $t('admin.orders.statuses.cancelled') }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <!-- Order Summary Modal -->
  <div v-if="showOrderSummary" class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div class="bg-[#4F4F4F] rounded-xl p-6 w-96 max-h-[80vh] overflow-y-auto">
      <!-- Header -->
      <div class="flex justify-between items-center mb-6">
        <h2 class="text-xl font-semibold text-white">Order Summary</h2>
        <button @click="showOrderSummary = false" class="text-white hover:text-gray-300">
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
      </div>

      <!-- Order Details -->
      <div class="space-y-3 mb-6">
        <div class="flex justify-between">
          <span class="text-white">Order#</span>
          <span class="text-white font-medium">42</span>
        </div>
        <div class="flex justify-between">
          <span class="text-white">Date</span>
          <span class="text-white font-medium">25/7/2025</span>
        </div>
        <div class="flex justify-between">
          <span class="text-white">Time</span>
          <span class="text-white font-medium">3:30 PM</span>
        </div>
      </div>

      <!-- Divider -->
      <div class="border-b border-[#1F1F1F] mb-6"></div>

      <!-- Ordered Items -->
      <div class="space-y-3 mb-6">
        <div class="flex justify-between">
          <span class="text-white">Creamy Sushi (3x)</span>
                      <span class="text-white">25.00</span>
        </div>
        <div class="flex justify-between">
          <span class="text-white">Panthouse Tonic (1x)</span>
                     <span class="text-white">12.00</span>
        </div>
        <div class="flex justify-between">
          <span class="text-white">Pumpkin Soup (2x)</span>
          <span class="text-white">12.00</span>
        </div>
        <div class="flex justify-between">
          <span class="text-white">Wagyu beef (5x)</span>
          <span class="text-white">12.00</span>
        </div>
      </div>

      <!-- Divider -->
      <div class="border-b border-[#1F1F1F] mb-6"></div>

      <!-- Financial Summary -->
      <div class="space-y-3 mb-8">
        <div class="flex justify-between">
          <span class="text-white">Subtotal</span>
          <span class="text-white">37.00</span>
        </div>
        <div class="flex justify-between">
          <span class="text-white">Tax</span>
          <span class="text-white">3.70</span>
        </div>
        <div class="flex justify-between text-lg font-semibold">
          <span class="text-white">Total</span>
          <span class="text-white">40.70</span>
        </div>
      </div>

      <!-- Edit Button -->
      <button class="w-full bg-[#F5BE32] text-white py-3 px-4 rounded-lg font-medium hover:bg-[#E5AE22] transition-colors">
        Edit
      </button>
    </div>
  </div>
</template>

<script>
export default {
name: 'AdminOrderSummary',
data() {
  return {
    showOrderSummary: false
  }
}
}
</script> 